var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { type: "text", placeholder: "请输入品牌名称" },
            model: {
              value: _vm.searchData.name,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "name", $$v)
              },
              expression: "searchData.name"
            }
          }),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { type: "text", placeholder: "请输入品牌编码" },
            model: {
              value: _vm.searchData.code,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "code", $$v)
              },
              expression: "searchData.code"
            }
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "200px" },
              attrs: {
                filterable: "",
                clearable: "",
                placeholder: "请选择状态"
              },
              model: {
                value: _vm.searchData.enabled,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "enabled", $$v)
                },
                expression: "searchData.enabled"
              }
            },
            [
              _c("el-option", { attrs: { label: "启用", value: "1" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "禁用", value: "0" } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.searchFun }
            },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "warning", icon: "el-icon-refresh" },
              on: { click: _vm.resetFun }
            },
            [_vm._v("重置")]
          ),
          _vm._v(" "),
          _vm.checkPermission(["brand:add"])
            ? _c(
                "el-button",
                {
                  staticClass: "filter-item",
                  attrs: { type: "primary", icon: "el-icon-plus" },
                  on: { click: _vm.addFun }
                },
                [_vm._v("新增")]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.newadd,
            width: "500px",
            "before-close": _vm.closeRefund,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.newadd = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "addForm",
              staticClass: "mark",
              attrs: {
                model: _vm.addData,
                rules: _vm.rules,
                "label-width": "160px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "品牌名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { type: "text", maxlength: "20" },
                    model: {
                      value: _vm.addData.name,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "name", $$v)
                      },
                      expression: "addData.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.title == "新增"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "品牌编码", prop: "code" } },
                    [
                      _c("el-input", {
                        attrs: { type: "text", maxlength: "20" },
                        model: {
                          value: _vm.addData.code,
                          callback: function($$v) {
                            _vm.$set(_vm.addData, "code", $$v)
                          },
                          expression: "addData.code"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "修改"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "品牌编码", prop: "code" } },
                    [
                      _c("el-input", {
                        attrs: { type: "text", disabled: "" },
                        model: {
                          value: _vm.addData.code,
                          callback: function($$v) {
                            _vm.$set(_vm.addData, "code", $$v)
                          },
                          expression: "addData.code"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否启用" } },
                [
                  _c("el-checkbox", {
                    attrs: { "false-label": 0, "true-label": 1 },
                    model: {
                      value: _vm.addData.enabled,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "enabled", $$v)
                      },
                      expression: "addData.enabled"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否独立用户群体" } },
                _vm._l(_vm.independentArr, function(item, index) {
                  return _c(
                    "el-radio",
                    {
                      key: index,
                      attrs: {
                        label: item.value,
                        disabled: _vm.title == "修改"
                      },
                      model: {
                        value: _vm.addData.independentUserSys,
                        callback: function($$v) {
                          _vm.$set(_vm.addData, "independentUserSys", $$v)
                        },
                        expression: "addData.independentUserSys"
                      }
                    },
                    [_vm._v(_vm._s(item.name))]
                  )
                }),
                1
              ),
              _vm._v(" "),
              _vm.title == "新增"
                ? _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSubmit }
                        },
                        [_vm._v("提交")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.onCencal } }, [
                        _vm._v("取消")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "修改"
                ? _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onUpdate }
                        },
                        [_vm._v("提交")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.onCencal } }, [
                        _vm._v("取消")
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dropdown",
        [
          _c("el-button", { attrs: { type: "primary", scoped: "" } }, [
            _vm._v("\n      显示/隐藏列\n      "),
            _c("i", { staticClass: "el-icon-arrow-down el-icon--right" })
          ]),
          _vm._v(" "),
          _c(
            "el-dropdown-menu",
            { attrs: { slot: "dropdown" }, slot: "dropdown" },
            _vm._l(_vm.tableColumns, function(column, index) {
              return _c(
                "el-dropdown-item",
                {
                  key: index,
                  nativeOn: {
                    click: function($event) {
                      return _vm.showHide(column.isShow)
                    }
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: column.isShow,
                        callback: function($$v) {
                          _vm.$set(column, "isShow", $$v)
                        },
                        expression: "column.isShow"
                      }
                    },
                    [_vm._v(_vm._s(column.label))]
                  )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "cell-style": _vm.isCenter,
            "header-cell-style": _vm.isCenter,
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "50" }
          }),
          _vm._v(" "),
          _vm._l(_vm.tableColumns, function(column, index) {
            return [
              column.isShow
                ? _c("el-table-column", {
                    key: index,
                    attrs: {
                      prop: column.prop,
                      label: column.label,
                      formatter: column.formatter,
                      width: column.width,
                      sortable: column.sortable
                    }
                  })
                : _vm._e()
            ]
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "360", prop: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.checkPermission(["brand:updata"])
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              icon: "el-icon-edit",
                              title: "修改",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.updateMenu(scope.row)
                              }
                            }
                          },
                          [_vm._v("修改")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.checkPermission(["brand:del"])
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "danger",
                              icon: "el-icon-delete",
                              title: "删除",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.delMenu(scope.row)
                              }
                            }
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.checkPermission(["brand:enabled"])
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "success",
                              icon: "el-icon-circle-check-outline",
                              title: "启用",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.auditFun(scope.row, "1")
                              }
                            }
                          },
                          [_vm._v("启用")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.checkPermission(["brand:enabled2"])
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "info",
                              icon: "el-icon-circle-close-outline",
                              title: "禁用",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.auditFun(scope.row, "0")
                              }
                            }
                          },
                          [_vm._v("禁用")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageData.total > 0,
                expression: "pageData.total>0"
              }
            ],
            attrs: {
              "current-page": _vm.pageData.page,
              "page-sizes": [10, 20, 30, 40, 50, 100, 200, 300, 400, 500],
              "page-size": _vm.pageData.rows,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pageData.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }